import {useNavigate} from 'services/hooks'
import {useI18n} from 'store/Store'
import {getFormattedDate, translateDanceStyle} from 'services/utils.js'

const UseDanceCard = (dance) => {
    const {i18n} = useI18n()
    const navigate = useNavigate()

    const goToDance = () => {
        navigate(`/dance/${dance?._id}`)
    }

    const t = (label, input) => i18n.t('dance.' + label, input)

    const formattedDate = getFormattedDate(dance?.creationDate, t)
    const danceStyle = translateDanceStyle(dance, t)

    return {
        t18Dance: (text) => i18n.t(`dance.${text}`),
        danceStyle,
        formattedDate,
        goToDance,
    }
}

export default UseDanceCard
